<template>
  <pict
    class="writing__image m-auto"
    block-name="writing"
    :default="imageProps.default"
    :sources="imageProps.sources"
    :alt="$t('alt')"
  />
</template>

<script>
import Pict from "@/shared/pict"
import imageL from "./images/writing.png"
import imageL2x from "./images/writing@2x.png"

export default {
  name: "WritingImage",
  components: {
    Pict
  },
  computed: {
    imageProps() {
      return {
        default: {
          src: imageL,
          srcset: {
            "2x": imageL2x
          }
        }
      }
    }
  },
  i18n: {
    messages: {
      en: {
        alt: "A person with long dark hair and wearing a blue short-sleeved shirt with yellow headphones on their head, listening to something and writing in a notebook and drinking from a yello mug."
      },
      de: {
        alt: "Eine Person mit blauem T-Shirt und gelben Kopfhörern, die mit einem gelben Smartphone verbunden sind, notiert etwas auf einem Blatt Papier."
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.writing {
  ::v-deep &__image {
    width: auto;
  }
}
</style>
